import {
  Table,
  Dialog,
  Button,
  Divider,
  TableRow,
  TableBody,
  TableCell,
  TableHead,
  DialogTitle,
  DialogContent,
  DialogActions,
  TableContainer,
} from '@mui/material';
import { fNumber } from 'src/utils/format-number';
import { fDate } from 'src/utils/format-time';
import InfoGrid from 'src/components/ui-kit/info-grid';
import { DepositTxType } from 'src/type/deposit';

type Props = {
  open: boolean;
  onClose: VoidFunction;
  tx: DepositTxType;
};

export default function StockImportViewDialog({ open, onClose, tx }: Props) {
  const getInfo = () => {
    if (!tx) return [];

    const { createdAt, updatedAt, product, amount, unitName, depositCostPerUnit } = tx;

    return [
      { label: 'สินค้า', value: product.name },
      { label: 'จำนวน', value: `${fNumber(amount, 3)} ${unitName}` },
      { label: `ราคา/${unitName}`, value: `${fNumber(depositCostPerUnit || 0, 3)}` },
      { label: 'วันที่ทำรายการ', value: fDate(createdAt, 'DD MMMM BBBB HH:mm น.') },
      { label: 'อัพเดทล่าสุด', value: fDate(updatedAt, 'DD MMMM BBBB HH:mm น.') },
    ];
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={open} onClose={onClose}>
      <DialogTitle sx={{ pb: 2, display: 'flex' }}>
        {tx.product.name} {tx.amount} {tx.unitName}
      </DialogTitle>

      <DialogContent>
        <TableContainer>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell />
                <TableCell align="center">น้ำหนัก</TableCell>
                <TableCell align="center">จำนวน</TableCell>
                {/* <TableCell align="center">คงเหลือ</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {tx?.productRedeemFees?.map((item) => (
                <TableRow key={item.id}>
                  <TableCell>{item?.productRedeemFee?.name}</TableCell>
                  <TableCell align="center">
                    {item?.productRedeemFee?.weight} {item?.productRedeemFee?.unitName}
                  </TableCell>
                  <TableCell align="center">{fNumber(item?.amount || 0)}</TableCell>
                  {/* <TableCell align="center">{fNumber(0)} บาท</TableCell> */}
                </TableRow>
              ))}
            </TableBody>
          </Table>

          <Divider style={{ borderStyle: 'dashed' }} />

          <Table size="small" sx={{ mt: 3 }}>
            <TableHead>
              <TableRow>
                <TableCell>น้ำหนักทองทั้งหมด</TableCell>
                <TableCell align="center">
                  {fNumber(tx?.amount || 0)} {tx?.unitName}
                </TableCell>
              </TableRow>

              <TableRow>
                <TableCell>ค่าธรรมเนียมทั้งหมด</TableCell>
                <TableCell align="center">{fNumber(tx?.fee || 0)} THB</TableCell>
              </TableRow>

              <TableRow>
                <TableCell>จำนวนทองคงเหลือ</TableCell>
                <TableCell align="center">
                  {fNumber(tx?.remainGoldAmount || 0)} {tx?.unitName}
                </TableCell>
              </TableRow>
            </TableHead>
          </Table>
        </TableContainer>
        <InfoGrid infos={getInfo()} />
      </DialogContent>

      <DialogActions>
        <Button variant="outlined" onClick={onClose}>
          ปิด
        </Button>
      </DialogActions>
    </Dialog>
  );
}
